import PropTypes from 'prop-types';
import React from 'react';
import _get from 'lodash/get';

import Box from 'ravenjs/lib/Box';

// eslint-disable-next-line valid-jsdoc
/**
 * A sample item-component for `DataGrid`
 */
function SampleDataGridItem(props) {
    const { item, gridProps } = props;
    const cellHeight = _get(gridProps, 'cellHeight');

    return (
        <Box elevation={5} height={`${cellHeight}px`} style={{ overflow: 'auto' }}>
            <pre>{JSON.stringify(item, null, 2)}</pre>
        </Box>
    );
}

SampleDataGridItem.propTypes = {
    gridProps: PropTypes.object,
    item: PropTypes.object,
};

SampleDataGridItem.defaultProps = {
    gridProps: null,
    item: null,
};

export default SampleDataGridItem;
